import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromUserSetting from './store/user-setting.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UserSettingEffects } from './store/user-setting.effects';
import { UserSettingFeatureComponent } from './feature/user-setting.feature';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { UserSettingRoute } from './user-setting.route';
import { UserSettingComponent } from '.';

@NgModule({
    declarations: [UserSettingFeatureComponent, UserSettingComponent],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        StoreModule.forFeature(
            fromUserSetting.userSettingsFeatureKey,
            fromUserSetting.reducer
        ),
        EffectsModule.forFeature([UserSettingEffects]),
        UIRouterModule.forChild({
            states: [UserSettingRoute]
        })
    ]
})
export class UserSettingModule {}
